<div class="vc-modal__innerContainer mmao__popin">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="vc-modal__title mmao__popin__title" i18n="@@MMAO.POPIN.TITLE">Negotiating Area</div>
  <vc-mmao
    [product]="data.product"
    [negotiation]="data.negotiation"
    [buyerId]="data.buyerId"
    [commentId]="data.commentId"
    (submitting)="isSubmitting($event)"
  >
  </vc-mmao>
</div>
